import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Nav } from '../../enums/nav.enum';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../services/storage.service';
import { StorageEnum } from '../../enums/storage.enum';
import { UserProfile } from '../../models/user-profile';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-mobile-nav',
  imports: [RouterModule],
  templateUrl: './mobile-nav.component.html',
  styleUrl: './mobile-nav.component.scss',
})
export class MobileNavComponent implements OnInit {
  isBrowser = false;
  env = environment;
  loginRes: UserProfile = new UserProfile();
  navState = this.getDefaultNavState();
  pageLabels: any;
  isLoggedIn = false;

  constructor(
    private readonly cmsS: CmsService,
    private readonly router: Router,
    @Inject(PLATFORM_ID) platformId: string,
    private readonly storageS: StorageService,
    private readonly utils: UtilService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.pageLabels = this.cmsS.flattenBuilderReferencesPreservingKeys(
        this.storageS.getSession(StorageEnum.GlobalVars)?.mobileNav,
      );
      this.setNav(window.location.pathname);
    }
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.setNav(event.urlAfterRedirects);
      }
    });
  }

  setNav(url: string): void {
    if (this.utils.isNullOrUndefined(this.storageS.getSession(StorageEnum.LoginResponse))) {
      this.isLoggedIn = false;
    } else {
      this.isLoggedIn = true;
    }
    this.navState = this.getDefaultNavState();
    this.showNavOnPage(url);
    this.env.mobileNavMargin = this.navState.ShowNav;
  }

  updateNavState(): void {
    this.loginRes = this.storageS.getSession(StorageEnum.LoginResponse);
    const acctStatus = this.loginRes?.Accounts[0].ServiceAddresses[0].SaStatusFlag;

    /**
     * 10 = PendingStart
     * 20 = Active
     * 30 = PendingStop
     * 40 = Stopped
     * 50 = Reactivated
     * 60 = Closed
     * 70 = Cancelled
     */
    switch (acctStatus) {
      case '10':
        this.navState.Pay = false;
        break;
      case '60':
      case '70':
        this.navState.ShowNav = false;
        break;
      default:
        this.navState.ShowNav = true;
        break;
    }
  }

  showNavOnPage(url: string): void {
    switch (true) {
      case url.includes(Nav.Login):
      case url.includes(Nav.Register):
      case url.includes(Nav.RegisterAccount):
      case url.includes(Nav.Forgot):
      case url.includes(Nav.OneTimePayment):
      case url.includes(Nav.OneTimePaymentSuccess):
      case url.includes(Nav.OneTimePaymentError):
      case url.includes(Nav.AccountLookup):
      case url.includes(Nav.MultiAccountSummary):
      case url.includes(Nav.UnauthenticatedRateRenewal):
      case url.includes(Nav.UnauthenticatedRateRenewalError):
      case url.includes(Nav.UnauthenticatedRateRenewalSuccess):
      case url.includes(Nav.Reset):
      case url.includes(Nav.BioTerms):
      case url.includes(Nav.UnauthenticatedPaperless):
      case url.includes(Nav.UnauthenticatedPaperlessError):
      case url.includes(Nav.UnauthenticatedPaperlessSuccess):
      case url.includes(Nav.AppError):
      case url.includes(Nav.Advantage) && !this.isLoggedIn:
        this.navState.ShowNav = false;
        break;
      default:
        this.navState.ShowNav = true;
        this.updateNavState();
        break;
    }
  }

  getDefaultNavState(): any {
    return {
      ShowNav: false,
      Home: true,
      Pay: true,
      Account: true,
      Activity: true,
      Perks: true,
    };
  }

  showMenuOption(optionID: any): any {
    switch (optionID) {
      case 'AccountSummary':
        return this.navState.Home;
      case 'Payment':
        return this.navState.Pay;
      case 'ManageAccount':
        return this.navState.Account;
      case 'Activity':
        return this.navState.Activity;
      case 'Perks':
        return this.navState.Perks;
      default:
        return true;
    }
  }

  setIcon(optionID: string): string {
    switch (optionID) {
      case 'AccountSummary':
        return 'fa-house';
      case 'Payment':
        return 'fa-dollar-sign';
      case 'ManageAccount':
        return 'fa-user';
      case 'Activity':
        return 'fa-wave-pulse';
      case 'Perks':
        return 'fa-hand-holding-star';
      default:
        return '';
    }
  }
}
